import React from "react";

const ToggleSwitch = ({
  label,
  subLabel,
  checked,
  onChange,
  activeText = "Active",
  inactiveText = "Inactive",
  className = "",
  disabled = false,
}) => {
  return (
    <div
      className={`flex items-center justify-between p-4 rounded-xl bg-slate-50 border border-slate-100 ${disabled ? "opacity-50" : ""} ${className}`}
    >
      <div className="flex flex-col">
        {label && (
          <span className="text-xs font-bold text-primary">{label}</span>
        )}
        {subLabel && (
          <span className="text-[9px] text-slate-500 uppercase font-bold tracking-tight">
            {subLabel}
          </span>
        )}
      </div>
      <label className={`relative inline-flex items-center ${disabled ? "cursor-not-allowed" : "cursor-pointer"}`}>
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => !disabled && onChange(e.target.checked)}
          disabled={disabled}
          className="sr-only peer"
        />
        <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-secondary"></div>
        <span className="ms-3 text-[11px] font-bold text-secondary uppercase">
          {checked ? activeText : inactiveText}
        </span>
      </label>
    </div>
  );
};

export default React.memo(ToggleSwitch);
